/**
 * @desc getPoSnBindStatistics
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<
  Array<defs.srm.SupplierPoSkuSnBindStatisticsResponseDto>
>;
export function request(pono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierSn/getPoSnBindStatistics/${pono}`, {
      method: "GET",

      ...options,
    }),
  );
}
